import { displayToast } from '@/components/ui/toast/displayToast'
import { ErrorResponse } from '../types/serviceTypes'
import { getErrorResponse } from './errorCodes'

/**
 * Displays bad request errors and dispatches notifications for other errors.
 *
 * @param errors - The errors object containing the error messages.
 * @returns The form errors object.
 */
const displayBadRequest = (errors: ErrorResponse['data']['errors']) => {
  const formErrors: Record<string, string> = {}
  const keys = Object.keys(errors)
  keys.forEach((key: string) => {
    errors[key].forEach((error: string) => {
      if (key.length > 0) formErrors[key] = getErrorResponse(error, key)
      else {
        const message = getErrorResponse(error)

        displayToast('error', 'Error', message)
      }
    })
  })
  return formErrors
}

const displayBadStatus = (status: number) => {
  const message = getErrorResponse(status)
  displayToast('error', 'Error', message)
}

/**
 * Displays an error message based on the API response status.
 * If the response status is 400, it calls the `displayBadRequest` function.
 * If the response status is neither 400 nor 401, it calls the `displayBadStatus` function.
 *
 * @param {APIResponse} response - The API response object.
 */
const displayError = (response: ErrorResponse) => {
  if (response.status === 400) return displayBadRequest(response.data.errors)
  if (response.status !== 400 && response.status !== 401)
    return displayBadStatus(response.status)
}

export default displayError
